<div class="wrapper">
  <div class="login-page">

    <div class="card">
      <div class="p-4 p-sm-5">
        <!-- Logo -->
        <div class="d-flex justify-content-center align-items-center">
          <div class="ui-w-60">
            <div class="w-100 position-relative" style="padding-bottom: 10%">
              <img src="assets/imagenes/logo-v2.png" alt="IML" width="200px">
            </div>
          </div>
        </div>
        <!-- / Logo -->
        <!-- Formulario para Login -->
        <div class="{{displayFormsLogin}}">
          <h5 class="text-center text-muted font-weight-normal mb-4">Ingrese a su cuenta</h5>
          <hr class="mt-0 mb-4">
          <form #loginForm="ngForm" class="form" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="form-group">
              <label for="username" class="form-label">Usuario</label><br>
              <input type="text" name="username" id="username" class="form-control" required [(ngModel)]="userName">
            </div>

            <div class="form-group">
              <label for="password" class="form-label">Contraseña</label><br>
              <div class="input-group">
                <input type="{{typeInput}}" name="password" id="password" class="form-control" required
                  [(ngModel)]="password">
                <div class="input-group-append">
                  <button id="show_password" class="btn btn-primary" type="button" (click)="mostrarPassword()">
                    <span class="fa {{iconTypeInput}}"></span>
                  </button>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="recordarUsuario"
                    [ngModelOptions]="{standalone: true}">
                  Recuérdame en éste dispositivo
                  <span class="form-check-sign">
                    <span class="check"></span>
                  </span>
                </label>
              </div>
              <br>
              <input type="submit" name="submit" class="btn btn-primary btn-md" value="Iniciar Sesión">
              <button type="button" class="btn btn-primary btn-neutral" style="float: right; margin-top: 20px;"
                (click)="mostrarFormRecuperarContresena()">¿Olvidó su contraseña?</button>
            </div>

          </form>
          <!-- Muestra los usuarios con contraseña guardada -->
          <div style="text-align: center">
            <button type="button" (click)="mostrarFormsLoginRemember()" [attr.aria-expanded]="true"
              aria-controls="collapseBasic" *ngIf="UsuarioRecordatorio.NombrePersonal">
              <img src="{{ipApi}}{{UsuarioRecordatorio.Imagen}}" class="img-fluid" alt="">
              <h6 class="">{{UsuarioRecordatorio.NombrePersonal}}</h6>
            </button>
          </div>
          <!-- Muestra los usuarios con contraseña guardada -->

        </div>
        <!-- Formulario para Login -->

        <!-- Formulario para recuperar la contraseña -->
        <div class="{{displayFormsCorreo}}">
          <h5 class="text-center text-muted font-weight-normal mb-4">Recuperar Contraseña</h5>
          <hr class="mt-0 mb-4">
          <form [formGroup]="correoForm" class="form" (submit)="enviarCorreo(correoForm)" novalidate autocomplete="off" style="text-align: center;">

            <div class="form-group">
              <label for="email" class="form-label">Ingrese su dirección de correo electrónico y le
                enviaremos un enlace para restablecer su contraseña.</label><br>
              <input formControlName="email" class="form-control" required>
            </div>

            <div class="form-group">
              <input type="submit" name="submit" class="btn btn-primary btn-md col-sm-12" value="Recuperar contraseña">
              <button class="btn btn-primary btn-neutral" style="margin-top: 20px;" (click)="mostrarFormLogin()">¿Ha
                recordado su contraseña?</button>
            </div>


          </form>
        </div>
        <!-- Formulario muestra los inicios de sesión guardados. -->
        <div class="{{displayFormsLoginRemember}}">
          <div class="formRecordatorio">
            <h3 class="text-center">Inicio de Sesión</h3>
            <img src="{{ipApi}}{{UsuarioRecordatorio.Imagen}}" class="img-fluid" alt="" style="margin-bottom: 10px;">
            <h5 class="">{{UsuarioRecordatorio.NombrePersonal}}</h5>
            <button type="button" class="btn btn-primary btn-md" (click)="iniciarUsuarioGuardado()">Iniciar
              Sesión</button>
            <button type="button" class="btn btn-primary btn-md" (click)="mostrarFormLogin()">Otro
              Usuario</button>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
